import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { QUERY_PARAM_KEY, QUERY_PARAM_VALUE } from '_constants/queryParams';

const QUERY_PARAM_VALUE_ARRAY = [
  QUERY_PARAM_VALUE.uploadDocuments,
  QUERY_PARAM_VALUE.confirmInfo,
  QUERY_PARAM_VALUE.checkingStages,
];

export const useTaxFilingQueryParam = () => {
  const [params, setParams] = useSearchParams();
  const currentParam = params.get(QUERY_PARAM_KEY.taxFilingTab);

  const setCurrentParam = (value) => {
    params.delete(QUERY_PARAM_KEY.taxFilingTab);
    params.append(QUERY_PARAM_KEY.taxFilingTab, value);
    setParams(params);
  };

  useEffect(() => {
    if (!QUERY_PARAM_VALUE_ARRAY.includes(currentParam)) {
      params.delete(QUERY_PARAM_KEY.taxFilingTab);
      params.append(QUERY_PARAM_KEY.taxFilingTab, QUERY_PARAM_VALUE.uploadDocuments);
      setParams(params);
    }
  }, [currentParam, params, setParams]);

  return [currentParam, setCurrentParam];
};
